'use strict';

import $ from 'jquery';

/**
 * Init Reveal elements
 */
export default class Reveal {

  constructor() {
    this.revealClassName = '.reveal';
    this.revealContentClassName = '.reveal__content';
    this.revealCloseClassName = '.close-button';
  }

  init() {
    let self = this;
    if ($( self.revealClassName).length ) {
      self.addInteractions();
    }
  } // end init: method

  addInteractions() {
    let self = this,
      revealSelector = $(self.revealClassName),
      revealContentSelector = $(self.revealContentClassName),
      revealCloseSelector = $(self.revealCloseClassName);

    // eventlistener Close: deleted classes
    revealSelector.on('closed.zf.reveal', function () {
      $(this).removeClass('opened');
      $('html').removeClass('is-reveal-open');
    });

    // eventListenner Open: refresh gallery and open reval
    revealSelector.on('open.zf.reveal', function () {
        $(this).find('.slick-prev').trigger('click'); // refresh slider
      $(this).addClass('opened');
    });

    //click out the gallery or details to close reveal
    revealSelector.on( 'click touchstart', function (event) {
        $(this).find(self.revealCloseClassName).trigger('click');
    });

    revealContentSelector.on( 'click touchstart', function (event) {
        event.stopPropagation();
    });

    revealCloseSelector.on( 'click touchstart', function (event) {
        event.stopPropagation();
        $(this).parent(self.revealClassName).removeClass('opened');
        $('html').removeClass('is-reveal-open');
        //revealSelector.trigger('closeme.zf.reveal'); // Closes any other modals that are currently open
        revealSelector.foundation('close');
    });

  } // end addInteractions: method



}
